import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '../../types/routes.enum';
/**
 * OAuth Signout Handler Component
 *
 * HOW THIS WORKS:
 * ----------------
 * 1. After SSO logout completes, the identity provider redirects back to this route
 * 2. Retrieves the saved post-logout destination from sessionStorage
 * 3. Cleans up the stored route and redirects the user appropriately
 *
 * NOTE: The actual signout is initiated by signOutUser() in useAuth.tsx
 */
const AuthSignoutComponent = () => {
  const navigate = useNavigate();
  useEffect(() => {
    const postLogoutRoute = sessionStorage.getItem('postLogoutRoute');
    sessionStorage.removeItem('postLogoutRoute');
    const redirectRoute = postLogoutRoute || `/${ROUTES.LOGIN}`;
    navigate(redirectRoute, { replace: true });
  }, []);
  return null;
};

export default AuthSignoutComponent;
